import { Button, Menu } from "antd";
import "../App.less";

const Main: React.FC = () => {
  return (
    <div style={{ height: "100vh", overflowY: "scroll" }}>
      <div
        id="top"
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flex: "0 1 50px",
            margin: "25px 0px 0px 25px",
          }}
        >
          <div>
            <img style={{ height: 40 }} src="./eac-logo.jpg"></img>
          </div>

          <Menu
            className="main-page-menu"
            theme="light"
            mode="horizontal"
            selectable={false}
            onClick={(info) => {
              document
                .getElementById(info.key)
                ?.scrollIntoView({ behavior: "smooth" });
            }}
            items={[
              {
                key: "1",
                label: "Pricing",
              },
              {
                key: "2",
                label: "Contact Us",
              },
              {
                key: "3",
                label: (
                  <a href="/dashboard" target="_blank">
                    Log In
                  </a>
                ),
              },
              {
                key: "4",
                label: (
                  <Button
                    className="btn-main"
                    shape="round"
                    type="primary"
                    href="/dashboard"
                    target="_blank"
                  >
                    Try for free
                  </Button>
                ),
              },
            ]}
          />
        </div>

        <div
          style={{
            background: "#017DAF",
            display: "flex",
            flexDirection: "column",
            flex: "0 1 1550px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: 80, padding: "0 300px", color: "white" }}>
            <b>OnRamp</b>
          </span>
          <span style={{ fontSize: 40, padding: "10px 200px", color: "white" }}>
            <span>Transforming </span>
            the way companies
            <b> Design, Manufacture, Connect to, and Service </b>
            their products.
          </span>
          <Button
            className="btn-main"
            shape="round"
            size="large"
            type="primary"
            href="/dashboard"
            target="_blank"
          >
            Try for free
          </Button>
        </div>
      </div>
      <div
        id="1"
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: 40 }}>The Right Price for You</span>
      </div>
      <div
        id="2"
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: 40 }}>Contact Us</span>
      </div>
      <span
        style={{
          position: "absolute",
          right: 35,
          bottom: 15,
          color: "#9D9D9D",
          cursor: "pointer",
        }}
        onClick={() =>
          document.getElementById("top")?.scrollIntoView({ behavior: "smooth" })
        }
      >
        Scroll to Top
      </span>
    </div>
  );
};

export default Main;
